export default "__VITE_ASSET__B_Fb8fch__"